import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WebtrekkConfigService } from '../webtrekk-config.service';
import { isPlatformBrowser } from '@angular/common';
//import { WebtrekkSmartPixelAngular } from '@webtrekk-smart-pixel/angular';

@Injectable({
  providedIn: 'root'
})
export class CartTrackingService {
  private platformId = inject(PLATFORM_ID);
  productsTodelete: any[] = [];
  productsToConfirmed: any[] = [];
  constructor(//private pixel: WebtrekkSmartPixelAngular,
    private webtrekk: WebtrekkConfigService
  ) { }
  viewedProduct(productCode: string, quantity: number, currentB2bUnitSendToWebtrack: string) {
    /* this.pixel.product('view', {
      id: productCode,
      quantity: quantity,
    }); */

    /*  this.pixel.action({
       name: 'NA_Product_Viewed_' + productCode + '_' + quantity + '_' + new Date()
     });
     this.pixel.trackAction(); */
    const product = {
      id: productCode,
      quantity: quantity,
    };
    const actionName = `NA_Product_Viewed_${productCode}_${quantity}_${new Date()}`;
    this.webtrekk.runWhenReady(() => {
      (window as any).wtSmart?.action?.data?.set({
        name: actionName,
        parameter: {
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart.product.view.data.set([product]);
      (window as any).wtSmart?.track();
      (window as any).wtSmart?.action?.data?.remove();
      (window as any).wtSmart.product.view.data.remove();
    });
  }
  trackAddToCart(productCode: string, quantity: number, cartId: string, page: string, currentB2bUnitSendToWebtrack: string) {

    const productToAdd = {
      id: productCode,
      quantity: quantity,
      parameter: {
        2: cartId,
        3: new Date().toISOString(),
        7: this.getCountryCode(),
        8: currentB2bUnitSendToWebtrack
      }
    };
    /*  this.pixel.product('addToCart', productToAdd);
     this.pixel.action({
       name: 'NA_AddToCart_' + page + '_' + cartId + '_' + productToAdd.id + '_' + productToAdd.quantity + '_' + new Date(),
       parameter: {
         2: cartId,
         3: new Date().toISOString()
       }
     });
     this.pixel.trackAction(); */
    const actionName = 'NA_AddToCart_' + page + '_' + cartId + '_' + productToAdd.id + '_' + productToAdd.quantity + '_' + new Date();
    this.webtrekk.runWhenReady(() => {
      (window as any).wtSmart?.action?.data?.set({
        name: actionName,
        parameter: {
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart.product.addToCart.data.set([productToAdd]);
      (window as any).wtSmart?.track();
      (window as any).wtSmart?.action?.data?.remove();
      (window as any).wtSmart.product.addToCart.data.remove();
    });
  }

  trackMultipleAddToCart(cartDetails: any, cartId: string, page: string, currentB2bUnitSendToWebtrack: string) {
    const addedProducts = cartDetails.cartEntries.map(product => ({
      id: product.product.code,
      action: 'addToCart',
      quantity: product.quantity,
      parameter: {
        2: cartId,
        3: new Date().toISOString(),
        7: this.getCountryCode(),
        8: currentB2bUnitSendToWebtrack
      }
    }));

    /*  this.pixel.products('addToCart', addedProducts);
     addedProducts.forEach(element => {
       this.pixel.action({
         name: 'NA_AddToCart_' + page + '_' + cartId + '_' + element.id + '_' + element.quantity + '_' + new Date(),
         parameter: {
           2: cartId,
           3: new Date().toISOString()
         }
       });
     });
 
     this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      addedProducts.forEach(element => {
        const actionName = `NA_AddToCart_${page}_${cartId}_${element.id}_${element.quantity}_${new Date().getTime()}`;
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart?.product?.addToCart?.data?.set([element]);
        (window as any).wtSmart?.track?.();
        (window as any).wtSmart?.product?.addToCart?.data?.remove();
      });
    });
  }

  deleteFromCart(productToDelete: any, cartId: string, page: string, currentB2bUnitSendToWebtrack: string) {
    const product = {
      id: productToDelete.product.code,
      cost: productToDelete.netPricePerPiece.formattedValue + productToDelete.netPricePerPiece.currencyIso,
      quantity: productToDelete.quantity,
      parameter: {
        2: cartId,
        3: new Date().toISOString(),
        7: this.getCountryCode(),
        8: currentB2bUnitSendToWebtrack
      }
    };
    /*  this.pixel.product('deleteFromCart', product);
     this.pixel.action({
       name: 'NA_deleteFromCart_' + page + '_' + cartId + '_' + product.id + '_' + product.quantity + '_' + new Date(),
       parameter: {
         2: cartId,
         3: new Date().toISOString()
       }
     });
     this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      const actionName = `NA_deleteFromCart_${page}_${cartId}_${product.id}_${product.quantity}_${new Date().getTime()}`;
      (window as any).wtSmart?.action?.data?.set({
        name: actionName,
        parameter: {
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart?.product?.deleteFromCart?.data?.set([product]);
      (window as any).wtSmart?.track?.();
      (window as any).wtSmart?.product?.deleteFromCart?.data?.remove();
    });
  }

  deleteFromCartAllProducts(productToDelete: any[], cartId: string, page: string, currentB2bUnitSendToWebtrack: string) {
    this.productsTodelete = [];
    productToDelete.forEach(product => {
      const prod = {
        id: product.product.code,
        action: 'deleteFromCart',
        cost: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
        quantity: product.quantity,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack

        }
      };
      this.productsTodelete.push(prod);
    });

    /* this.pixel.products('deleteFromCart', this.productsTodelete);
    this.productsTodelete.forEach(element => {
      this.pixel.action({
        name: 'NA_deleteFromCart_' + page + '_' + cartId + '_' + element.id + '_' + element.quantity + '_' + new Date(),
        parameter: {
          2: cartId,
          3: new Date().toISOString()
        }
      });
    });
    this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      this.productsTodelete.forEach(element => {
        const actionName = `NA_deleteFromCart_${page}_${cartId}_${element.id}_${element.quantity}_${new Date().getTime()}`;
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart?.product?.deleteFromCart?.data?.set([element]);
        (window as any).wtSmart?.track?.();
        (window as any).wtSmart?.product?.deleteFromCart?.data?.remove();
      });
    });
  }

  trackQuantityChange(qty: number, item: any, cartId, currentB2bUnitSendToWebtrack: string): void {
    const oldqty = Number(item.formattedQuantity);
    if (oldqty > qty) {
      const product = {
        id: item.product.code,
        quantity: oldqty - qty,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack

        }
      };
      //this.pixel.product('deleteFromCart', product);
      this.webtrekk.runWhenReady(() => {
        const actionName = `NA_Quantity_Change_CART_PAGE_${cartId}_${item.product.code}_${item.formattedQuantity}_${qty}_${new Date()}`;
        (window as any).wtSmart?.action?.data?.set({ name: actionName });
        (window as any).wtSmart?.product?.deleteFromCart?.data?.set([product]);
        (window as any).wtSmart?.track?.();
        (window as any).wtSmart?.product?.deleteFromCart?.data?.remove();

      });
    }
    else if (oldqty < qty) {
      const product = {
        id: item.product.code,
        quantity: qty - oldqty,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack

        }
      };
      //this.pixel.product('addToCart', product);
      this.webtrekk.runWhenReady(() => {
        const actionName = `NA_Quantity_Change_CART_PAGE_${cartId}_${item.product.code}_${item.formattedQuantity}_${qty}_${new Date()}`;
        (window as any).wtSmart?.action?.data?.set({ name: actionName });
        (window as any).wtSmart?.product?.addToCart?.data?.set([product]);
        (window as any).wtSmart?.track?.();
        (window as any).wtSmart?.product?.addToCart?.data?.remove();

      });
    }
    /*  this.pixel.action({
       name: 'NA_Quantity_Change_' + 'CART_PAGE' + '_' + cartId + '_' + item.product.code + '_' + item.formattedQuantity + '_' + qty + '_' + new Date(),
       parameter: {
         2: cartId,
         3: new Date().toISOString()
       }
     });
     this.pixel.trackAction(); */
    const actionName = `NA_Quantity_Change_CART_PAGE_${cartId}_${item.product.code}_${item.formattedQuantity}_${qty}_${new Date()}`;
    this.webtrekk.runWhenReady(() => {
      (window as any).wtSmart?.action?.data?.set({
        name: actionName,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart?.track();
    });
  }

  trackQuantityZeroChange(productToDelete: any, cartId: string, page: string, currentB2bUnitSendToWebtrack: string) {
    const product = {
      id: productToDelete.product.code,
      cost: productToDelete.netPricePerPiece.formattedValue + productToDelete.netPricePerPiece.currencyIso,
      quantity: productToDelete.formattedQuantity,
      parameter: {
        2: cartId,
        3: new Date().toISOString()
      }
    };
    /* this.pixel.product('deleteFromCart', product);
    this.pixel.action({
      name: 'NA_deleteFromCart_' + page + '_' + cartId + '_' + product.id + '_' + product.quantity + '_' + new Date(),
      parameter: {
        2: cartId,
        3: new Date().toISOString()
      }
    });
    this.pixel.trackAction(); */
    const actionName = `NA_deleteFromCart_${page}_${cartId}_${product.id}_${product.quantity}_${new Date()}`;
    this.webtrekk.runWhenReady(() => {
      (window as any).wtSmart?.action?.data?.set({
        name: actionName,
        parameter: {
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart.product.deleteFromCart.data.set([product]);
      (window as any).wtSmart?.track();
      (window as any).wtSmart?.action?.data?.remove();
      (window as any).wtSmart.product.deleteFromCart.data.remove();
    });
  }
  trackCheckout(cartDetails: any, cartId, currentB2bUnitSendToWebtrack?: string) {
    const checkoutProducts = cartDetails.map(product => ({
      id: product.product.code,
      action: 'Checkout',
      price: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
      quantity: product.formattedQuantity,
      parameter: {
        2: cartId,
        3: new Date().toISOString()
      }
    }));
    /* this.pixel.products('checkout', checkoutProducts);
    checkoutProducts.forEach(element => {
      this.pixel.action({
        name: 'NA_Checkout_' + 'CART_PAGE' + '_' + cartId + '_' + element.id + '_' + element.quantity + '_' + new Date(),
        parameter: {
          2: cartId,
          3: new Date().toISOString()
        }
      });
    });
    this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      checkoutProducts.forEach(element => {
        const actionName = `NA_Checkout_CART_PAGE_${cartId}_${element.id}_${element.quantity}_${new Date().getTime()}`;
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart?.product?.checkout?.data?.set([element]);
        (window as any).wtSmart?.track?.();
        (window as any).wtSmart?.product?.checkout?.data?.remove();
      });
    });
  }

  trackCheckoutStep(cartId: string, step: string, currentB2bUnitSendToWebtrack: string, orderId?: string) {
    if (!orderId) {
      /*  this.pixel.action({
         name: 'NA_Checkout_Checkout_CartID_' + cartId + '_step_' + step + '_' + new Date(),
         parameter: {
           2: cartId,
           3: new Date().toISOString()
         }
       }); */
      const actionName = `NA_Checkout_CartID__${cartId}__step_${step}_${new Date()}`;
      this.webtrekk.runWhenReady(() => {
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            2: cartId,
            3: new Date().toISOString(),
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart?.track();
        (window as any).wtSmart?.action?.data?.remove();
      });
    }
    else {
      /*  this.pixel.action({
         name: 'NA_Checkout_CartID_' + cartId + '_OrderID_' + orderId + '_step_' + step + '_' + new Date(),
         parameter: {
           2: cartId,
           3: new Date().toISOString()
         }
       }); */
      const actionName = `NA_Checkout_CartID__${cartId}'_OrderID_'${orderId}_step_${step}_${new Date()}`;
      this.webtrekk.runWhenReady(() => {
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            2: cartId,
            3: new Date().toISOString(),
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart?.track();
        (window as any).wtSmart?.action?.data?.remove();
      });
    }
    //this.pixel.trackAction();
  }
  trcakOrder(site: string, orderId: string, orderValue: number, currency: string, orderStatus: string, entries, currentB2bUnitSendToWebtrack: string) {
    /*  this.pixel.order({
       id: site + '_' + orderId,
       value: orderValue,
       currency: currency,
       orderStatus: orderStatus
     }); */
    this.webtrekk.runWhenReady(() => {
      const actionName = `${site}_Order_Placed_${orderId}_${orderStatus}_${new Date().getTime()}`;
      (window as any).wtSmart?.action?.data?.set({
        name: actionName,
        parameter: {
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart.order.parameter.set({
        id: site + '_' + orderId,
        value: orderValue,
        currency: currency,
        orderStatus: orderStatus
      });
      (window as any).wtSmart?.track();
      (window as any).wtSmart?.action?.data?.remove();
      (window as any).wtSmart.order.parameter.remove()
    });
    this.productsToConfirmed = [];
    entries?.forEach(product => {
      const prod = {
        id: product.product.code,
        action: 'confirmation',
        cost: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
        quantity: product.quantity,
      };
      this.productsToConfirmed.push(prod);
    });
    this.webtrekk.runWhenReady(() => {
      this.productsToConfirmed.forEach(element => {
        const actionName = `${site}_Order_Placed_${orderId}_${orderStatus}_${new Date().getTime()}`;
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart?.product?.confirmation?.data?.set([element]);
        (window as any).wtSmart?.track?.();
        (window as any).wtSmart?.action?.data?.remove();
        (window as any).wtSmart?.product?.confirmation?.data?.remove();
      });
    });
    /*  this.pixel.products('confirmation', this.productsToConfirmed);
     this.pixel.action({
       name: site + '_Order_Placed_' + orderId + '_' + orderStatus + '_' + new Date(),
     }); */
    //this.pixel.trackAction();
  }

  trackSaveCart(cartId: string, CartName: string, currentB2bUnitSendToWebtrack: string, cartDetails?: any[]) {
    if (cartDetails) {
      const saveCartProducts = cartDetails?.map(product => ({
        id: product.product.code,
        action: 'SaveCart',
        price: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
        quantity: product.formattedQuantity,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      }));
    }
    /* this.pixel.action({
      name: 'NA_SaveCart' + cartId + '_' + CartName + '_' + new Date(),
      parameter: {
        2: cartId,
        3: new Date().toISOString()
      }
    });
    this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      const actionName = `NA_SaveCart_${cartId}_${CartName}_${new Date()}`;
      (window as any).wtSmart?.action?.data?.set({
        name: actionName, parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart?.track?.();
    });
  }

  trackRestoreCart(oldCartId, cartId: string, CartName: string, currentB2bUnitSendToWebtrack: string, cartDetails?: any[]) {
    if (cartDetails) {
      const restoreCartProducts = cartDetails?.map(product => ({
        id: product.product.code,
        action: 'SaveCart',
        price: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
        quantity: product.formattedQuantity,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      }));
    }
    /*   this.pixel.action({
        name: 'NA_RestoreCart' + oldCartId + '_' + cartId + '_' + CartName + '_' + new Date(),
        parameter: {
          2: cartId,
          3: new Date().toISOString()
        }
      });
      this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      const actionName = `NA_RestoreCart_${oldCartId}_${cartId}_${CartName}_${new Date()}`;
      (window as any).wtSmart?.action?.data?.set({
        name: actionName, parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart?.track?.();
    });

  }
  trackEditCart(cartId: string, CartName: string, currentB2bUnitSendToWebtrack: string, cartDetails?: any[]) {
    if (cartDetails) {
      const editCartProducts = cartDetails?.map(product => ({
        id: product.product.code,
        action: 'SaveCart',
        price: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
        quantity: product.formattedQuantity,
        parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      }));
    }
    /*  this.pixel.action({
       name: 'NA_SavedCart_Edit' + cartId + '_' + CartName + '_' + new Date(),
       parameter: {
         2: cartId,
         3: new Date().toISOString()
       }
     });
     this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      const actionName = `NA_SavedCart_Edit_${cartId}_${CartName}_${new Date()}`;
      (window as any).wtSmart?.action?.data?.set({
        name: actionName, parameter: {
          2: cartId,
          3: new Date().toISOString(),
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart?.track?.();
    });

  }

  trackImportedCart(cartId: string, CartName: string, currentB2bUnitSendToWebtrack: string, cartDetails?: any[]) {
    /*  let editCartProducts = cartDetails.map(product => ({
       id: product.product.code,
       action: 'SaveCart',
       price: product.netPricePerPiece.formattedValue + product.netPricePerPiece.currencyIso,
       quantity: product.formattedQuantity
     })); */
    /*  this.pixel.action({
       name: 'ImportOrder'
     });
     this.pixel.trackAction(); */
    this.webtrekk.runWhenReady(() => {
      (window as any).wtSmart?.action?.data?.set({
        name: 'ImportOrder',
        parameter: {
          7: this.getCountryCode(),
          8: currentB2bUnitSendToWebtrack
        }
      });
      (window as any).wtSmart?.track?.();
    });

  }
  plpPageViewProduct(products: any, currentB2bUnitSendToWebtrack: string) {
    products?.forEach((product) => {
      const productviewedFromPLP = {
        id: product.code,
        quantity: 1,
      };
      /*  this.pixel.product('list', productviewedFromPLP);
       this.pixel.action({
         name: 'NA_PLP_page' + productviewedFromPLP.id + '_' + productviewedFromPLP.quantity + '_' + new Date(),
       });
       this.pixel.trackAction(); */
      this.webtrekk.runWhenReady(() => {
        const actionName = `NA_PLP_page_${productviewedFromPLP.id}_${productviewedFromPLP.quantity}_${new Date().getTime()}`;
        (window as any).wtSmart?.action?.data?.set({
          name: actionName,
          parameter: {
            7: this.getCountryCode(),
            8: currentB2bUnitSendToWebtrack
          }
        });
        (window as any).wtSmart.product.list.data.set([product]);
        (window as any).wtSmart?.track();
        (window as any).wtSmart?.action?.data?.remove();
        (window as any).wtSmart.product.list.data.remove();
      });
    })
  }
  getCountryCode(): string {
    return isPlatformBrowser(this.platformId) ? window.location.pathname.split('/')[1] : '';
  }
}
